export default __webpack_public_path__ + "static/media/terraform.465acf86.svg";